var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.component,{tag:"Component",class:['ui-heading', _vm.weight && `ui-heading--weight-${_vm.weight}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }